import React from "react";
import Modal from "react-modal";
import { ReactComponent as PlusIcon } from "src/assets/plus.svg";
import ImageCrop from "../ImageCrop";

interface ProfilePhotoSectionProps {
    profilePreview: string | undefined;
    profileError?: string;
    profileRef: React.RefObject<HTMLDivElement>;
    fileInputProfileRef: React.RefObject<HTMLInputElement>;
    handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    showImageCrop: boolean;
    closeImageCrop: () => void;
    image: string | null;
    handleCrop: (cropData: string) => void;
}

const ProfilePhotoSection: React.FC<ProfilePhotoSectionProps> = ({
    profilePreview,
    profileError,
    profileRef,
    fileInputProfileRef,
    handleFileChange,
    showImageCrop,
    closeImageCrop,
    image,
    handleCrop,
}) => {
    return (
        <>
            <label className="flex flex-col gap-4" id="authorProfile">
                <span className="title">
                    작가님의 <span className="point">프로필 사진</span>을 등록해 주세요
                </span>
            </label>

            <div
                ref={profileRef}
                className="flex flex-col lg:flex-row items-center lg:items-start justify-center gap-6 w-full"
            >
                <div className="flex flex-col items-center flex-shrink-0">
                    <div className="w-[180px] h-[180px] lg:w-[220px] lg:h-[220px] relative">
                        <div
                            id="img-preview"
                            className="w-[180px] h-[180px] lg:w-[220px] lg:h-[220px] rounded-full overflow-hidden mb-4 border border-gray-300 shadow-sm"
                        >
                            {profilePreview ? (
                                <img
                                    className="w-full h-full object-cover"
                                    src={profilePreview}
                                    alt="Profile Preview"
                                />
                            ) : (
                                <div
                                    className={`w-full h-full bg-[#C1C1C1]
                                        ${profileError ? "border-red-500" : "border-[#DBDBDB]"}
                                        border rounded-full flex items-center justify-center`}
                                />
                            )}
                        </div>
                    </div>

                    <div className="mt-2">
                        <button className="relative w-[130px] h-[38px] lg:w-[150px] lg:h-[38px] font-base rounded-full bg-main cursor-pointer text-white flex items-center justify-center space-x-1.5 transition-all duration-200 active:scale-95">
                            <PlusIcon className="w-4 h-4" />
                            <span className="font-namsan text-[13px] font-semibold">
                                프로필 업로드
                            </span>
                            <input
                                id="profileInput"
                                ref={fileInputProfileRef}
                                className="absolute top-0 left-0 opacity-0 w-full h-full cursor-pointer"
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                            />
                        </button>
                    </div>
                </div>

                <div className="w-full max-w-[500px] lg:max-w-none lg:flex-1 px-2 lg:px-0">
                    <div className="border border-[#DBDBDB] w-full shadow-sm bg-[#F6F6F6] rounded-2xl p-5 flex items-center">
                        <div className="font-namsan-EB text-[#5A5A5A] w-full text-[12px] lg:text-[13px] leading-relaxed">
                            [프로필 사진 업로드 규격 안내]
                            <br />
                            <br />
                            최소 400 X 400 (px)
                            <br />
                            최대 800 x 1080 (px)
                            <br />
                            <br />
                            업로드 사진은 최대 1mb까지 가능합니다.
                            <br />
                            <br />
                            <div className="text-[#8C8C8C] font-namsan-B">
                                작가님이 어떤 분인지 알릴 수 있는 프로필 사진 기능입니다.
                                <br />
                                본인 식별이 가능한 사진으로 등록해 주세요.
                                <br />
                                <br />
                                선정적인 사진 또는 업로드에 적합하지 않은 기타 사유가 확인될 경우
                                반려될 수 있습니다.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {profileError && (
                <p className="text-red-500 font-namsan text-[12px] font-bold">{profileError}</p>
            )}

            <Modal
                isOpen={showImageCrop}
                shouldCloseOnOverlayClick={false}
                onRequestClose={closeImageCrop}
                contentLabel="imageCrop Modal"
                className="modal-login"
                ariaHideApp={false}
                overlayClassName="overlay"
            >
                {image && (
                    <ImageCrop
                        image={image}
                        onClose={closeImageCrop}
                        onCrop={handleCrop}
                        imageType="profile"
                    />
                )}
            </Modal>
        </>
    );
};

export default ProfilePhotoSection;
